import _ from 'lodash'
import { useSearchParams } from 'react-router-dom'

import type { NDParamsType, OrdersParamsType } from '../types'

export type ParamsType = OrdersParamsType | NDParamsType

const useParams = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const createParamsByObject = (data: ParamsType) => {
    const clearedData = _.omitBy(data, (value) => value === '')
    setSearchParams(clearedData, { replace: true })
  }

  const getParams = () => {
    const paramsObject = {} as Record<string, string>
    searchParams.forEach((value, index) => {
      paramsObject[index] = value
    })
    return paramsObject
  }

  const clearParamsExcept = (data: string[]) => {
    const paramsObject = {} as Record<string, string>
    searchParams.forEach((value, index) => {
      if (data.includes(index)) paramsObject[index] = value
    })

    createParamsByObject(paramsObject as unknown as ParamsType)
  }

  const clearParams = () => {
    setSearchParams({}, { replace: true })
  }

  return {
    clearParams,
    clearParamsExcept,
    createParamsByObject,
    getParams,
  }
}

export default useParams
